import axios from "axios";
import { refreshToken } from "../session";

export async function sendEvent(event: string, count: number, metadata: Record<string, any> = {}): Promise<boolean> {
    try {
        const jwt = localStorage.getItem('jwt');
        if (!jwt) return false;
  
        const res = await axios.post(`https://api.abogalia.com.ar/abogalia/api/v1/users/event`,
          {
            event_type: event,
            metadata: metadata,
          },
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
              Accept: 'application/json',
            },
          }
        );
  
        if (res.status === 200) {
          return true;
        }
        return false;
    } catch (error: any) {
        if (error.response && error.response.status === 401 && count === 0) {
            const shouldRetry = await refreshToken(null);
            if (shouldRetry) {
                await sendEvent(event, 1);
            }
        }
        
        return false;
    }
}